import React, { useState, useEffect } from "react";
import GoogleMapReact from 'google-map-react';
import axios from 'axios';
import CustomMarker from './CustomMarker';
import { Div, Text, Icon } from 'atomize';

const SimpleMap = ({ address }) => {
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [mapError, setMapError] = useState(null);

  useEffect(() => {
    // Listen for Google Maps API errors
    const handleGoogleMapsError = (error) => {
      console.error('Google Maps API Error:', error);
      setMapError(error.message || 'Unknown error');
      setError(true);
    };

    window.gm_authFailure = () => {
      console.error('Google Maps Authentication Failed - Check API key');
      setMapError('API key authentication failed');
      setError(true);
    };

    const fetchCoordinates = async () => {
      setLoading(true);
      setError(false);
      try {
        console.log('Fetching coordinates for address:', address);
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=AIzaSyAYcLmcjNrpVgFMVMXnmoBaiKCfuZOKZZ4`
        );
        console.log('Geocoding response:', response.data);

        if (response.data.status === 'REQUEST_DENIED') {
          console.error('Geocoding API request denied:', response.data.error_message);
          setMapError(response.data.error_message || 'Request denied');
          setError(true);
        } else if (response.data.results && response.data.results.length > 0) {
          const { lat, lng } = response.data.results[0].geometry.location;
          console.log('Coordinates found:', { lat, lng });
          setCoordinates({ lat, lng });
        } else {
          console.error('No results found for address:', address);
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching the coordinates: ", error);
        setMapError(error.message);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (address) {
      fetchCoordinates();
    }

    return () => {
      window.gm_authFailure = undefined;
    };
  }, [address]);

  const defaultProps = {
    center: coordinates,
    zoom: 11
  };

  return (
    <Div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }}
      h={{xs:"10rem", md:"12rem"}}
      w="100%"
      rounded="lg"
      bg="#e8e8e8"
    >
      {loading ? (
        <Icon name="Loading3" size="3rem" color="#654b1e" />
      ) : error ? (
        <Text textColor="black" textWeight="500" textSize="caption" textAlign="center" p="1rem">
          {mapError ? `Map Error: ${mapError}` : 'Map unavailable'}
        </Text>
      ) : (
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyAYcLmcjNrpVgFMVMXnmoBaiKCfuZOKZZ4" }}
          center={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => {
            console.log('Google Maps API loaded successfully', map, maps);
          }}
          onChildClick={(key) => console.log('Marker clicked:', key)}
          options={{
            fullscreenControl: false,
            zoomControl: true
          }}
        >
          <CustomMarker
            lat={coordinates.lat}
            lng={coordinates.lng}
          />
        </GoogleMapReact>
      )}
    </Div>
  );
}

export default SimpleMap;